import DeleteAccountModal from './DeleteAccountModal'

export default DeleteAccountModal
